<header id="control-bar-wrapper" [class.top-nav-layout]="enableTopNav">
  <div
    id="control-bar"
    [class.mobile]="mobile"
    [class.no-sidebar]="noSidebar"
    [class.border-bottom]="borderBottom"
    [class.top-nav-layout]="enableTopNav"
    data-atm="page-control-bar">
    <div
      class="container"
      [class.short]="style === 'short'"
      [class.long]="style === 'long'"
      [class.no-action]="!hasActions">
      <div class="title" (click)="handleReturnTo()" data-atm="page-title">
        <div [class.returnTo]="returnTo">
          <div *ngIf="returnTo">
            <button mat-icon-button class="return-button">
              <img src="/assets/icon/next.svg" />
            </button>
          </div>
          <ng-content select="[title]"></ng-content>
        </div>
      </div>
      <div class="action">
        <ng-content select="[action]"></ng-content>
      </div>
    </div>
  </div>

  <div class="s64"></div>

  <div
    class="banner"
    [class.slide-down]="banner"
    [class.warning]="banner?.class === bannerClass.warning">
    <div class="massage-wrapper">
      <mat-icon class="error-icon" *ngIf="banner?.class === bannerClass.warning"
        >error</mat-icon
      >
      <span class="massage" [innerHTML]="banner?.message"></span>
    </div>
    <mat-icon
      *ngIf="banner?.canDismiss"
      (click)="banner = null"
      class="close-banner"
      >close</mat-icon
    >
  </div>
</header>
